/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import {
  AutoRegionReference_Enum,
  autoRegionReference_EnumFromJSON,
  autoRegionReference_EnumToJSON,
} from "./auto_region_reference";

export const protobufPackage = "user_camera";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface AutoRegionRequest {
  utime: number;
  region: number[];
  reference: AutoRegionReference_Enum;
}

function createBaseAutoRegionRequest(): AutoRegionRequest {
  return { utime: 0, region: [], reference: 0 };
}

export const AutoRegionRequest = {
  encode(message: AutoRegionRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).sint64(message.utime);
    }
    writer.uint32(18).fork();
    for (const v of message.region) {
      writer.float(v);
    }
    writer.ldelim();
    if (message.reference !== 0) {
      writer.uint32(24).int32(message.reference);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AutoRegionRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAutoRegionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.sint64() as Long);
          continue;
        case 2:
          if (tag === 21) {
            message.region.push(reader.float());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.region.push(reader.float());
            }

            continue;
          }

          break;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.reference = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AutoRegionRequest {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      region: globalThis.Array.isArray(object?.region) ? object.region.map((e: any) => globalThis.Number(e)) : [],
      reference: isSet(object.reference) ? autoRegionReference_EnumFromJSON(object.reference) : 0,
    };
  },

  toJSON(message: AutoRegionRequest): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.region?.length) {
      obj.region = message.region;
    }
    if (message.reference !== 0) {
      obj.reference = autoRegionReference_EnumToJSON(message.reference);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AutoRegionRequest>, I>>(base?: I): AutoRegionRequest {
    return AutoRegionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AutoRegionRequest>, I>>(object: I): AutoRegionRequest {
    const message = createBaseAutoRegionRequest();
    message.utime = object.utime ?? 0;
    message.region = object.region?.map((e) => e) || [];
    message.reference = object.reference ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
